import React from 'react'
import { Image, Center } from '@chakra-ui/react'
import { StatusIcon } from 'components/ImageUpload/StatusIcon'
import { DropzoneRootProps } from 'react-dropzone'

interface Props {
  imageUrl: string
  style: DropzoneRootProps
  isDragAccept: boolean
  isDragReject: boolean
}

export const CoverComponent: React.FC<Props> = ({
  imageUrl,
  style,
  isDragAccept,
  isDragReject,
}) => {
  return (
    <Center
      {...style}
      position="relative"
      h="15rem"
      border="1px"
      borderColor="gray.200"
    >
      <Image
        alt="profile-background"
        objectFit="cover"
        src={imageUrl}
        fallbackSrc={'/images/quiz_bg.png'}
        w="100%"
        h="100%"
      />
      <Center
        w="100%"
        h="100%"
        position={'absolute'}
        bg="blackAlpha.300"
        pr={3}
        pb={2}
        _hover={{ bg: 'blackAlpha.600' }}
      >
        <StatusIcon
          imageUrl={imageUrl}
          isDragAccept={isDragAccept}
          isDragReject={isDragReject}
        />
      </Center>
    </Center>
  )
}
